import { useEffect } from "react";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";

const FAQPage = () => {
  useEffect(() => {
    document.title = "FAQ - E-commerce Onboarding Questions Answered | BrandBorn";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Frequently asked questions about e-commerce onboarding with BrandBorn. Learn about Myntra seller registration, Nykaa onboarding process, Blinkit listing, pricing, timelines, and more.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-16" data-testid="faq-page">
      <section className="bg-black text-white py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            Frequently Asked <span className="text-red-500">Questions</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Everything you need to know about marketplace onboarding, brand registration, and growing your e-commerce business with BrandBorn.
          </p>
        </div>
      </section>
      <FAQ />
      <Contact />
    </div>
  );
};

export default FAQPage;
